module.exports = __webpack_public_path__ + "img/speakwell-desc-mb.daadecd6.png";